import React, { useCallback, useEffect, useRef, useState } from "react";
import hkRestaurant from "../assets/images/hk-restaurant.png";
import sarMal from "../assets/images/sarmal.png";
import movieExplorer from "../assets/images/movie-explorer.png";
import giftoriaHome from "../assets/images/giftoria-home.png";
import giftoriaProduct from "../assets/images/giftoria-product.png";
import giftoriaAdminDashboard from "../assets/images/giftoria-admin-dashboard.png";
import giftoriaAdminProduct from "../assets/images/giftoria-admin-product.png";
import giftoriaAdminOrder from "../assets/images/giftoria-admin-order.png";
import tripGenieHomeEng from "../assets/images/home-eng.png";
import tripGenieHomeMm from "../assets/images/home-mm.png";
import tripGenieDestination from "../assets/images/choose-destination.png";
import tripGenieDate from "../assets/images/date.png";
import tripGenieTravellers from "../assets/images/travellers.png";
import tripGenieBudget from "../assets/images/budget.png";
import tripGenieInterest from "../assets/images/choose-interest.png";
import tripGenieResult from "../assets/images/result.png";
import tripGenieFlight from "../assets/images/flight.png";
import tripGenieHotels from "../assets/images/hotels.png";
import tripGenieTips from "../assets/images/tips.png";
import { motion, AnimatePresence } from "framer-motion";
import { AiFillCloseCircle } from "react-icons/ai";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";

const slideVariants = {
  enter: (direction) => ({
    x: direction > 0 ? 48 : -48,
    opacity: 0,
  }),
  center: {
    x: 0,
    opacity: 1,
  },
  exit: (direction) => ({
    x: direction > 0 ? -48 : 48,
    opacity: 0,
  }),
};

const ProjectImageSlider = ({ images, title }) => {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const touchStartX = useRef(0);
  const hasMultiple = images.length > 1;

  const paginate = useCallback(
    (delta) => {
      if (!hasMultiple) return;
      setDirection(delta);
      setIndex((current) => (current + delta + images.length) % images.length);
    },
    [hasMultiple, images.length]
  );

  const goTo = (nextIndex) => {
    if (nextIndex === index) return;
    setDirection(nextIndex > index ? 1 : -1);
    setIndex(nextIndex);
  };

  useEffect(() => {
    if (!hasMultiple) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "ArrowRight") paginate(1);
      if (event.key === "ArrowLeft") paginate(-1);
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [hasMultiple, paginate]);

  const onTouchStart = (event) => {
    touchStartX.current = event.changedTouches[0].clientX;
  };

  const onTouchEnd = (event) => {
    const deltaX = event.changedTouches[0].clientX - touchStartX.current;
    if (Math.abs(deltaX) < 40) return;
    paginate(deltaX < 0 ? 1 : -1);
  };

  return (
    <div
      className="relative overflow-hidden rounded-lg bg-gray-100 dark:bg-gray-800"
      role={hasMultiple ? "region" : undefined}
      aria-roledescription={hasMultiple ? "carousel" : undefined}
      aria-label={`${title} screenshots`}
    >
      <div
        className="relative h-64"
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
      >
        <AnimatePresence initial={false} custom={direction} mode="wait">
          <motion.img
            key={index}
            src={images[index]}
            alt={`${title} screenshot ${index + 1}`}
            custom={direction}
            variants={slideVariants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{ duration: 0.22, ease: "easeOut" }}
            className="absolute inset-0 h-full w-full object-cover object-center"
            draggable={false}
          />
        </AnimatePresence>
      </div>

      {hasMultiple && (
        <>
          <span className="sr-only" aria-live="polite">
            Image {index + 1} of {images.length}
          </span>
          <button
            type="button"
            onClick={() => paginate(-1)}
            aria-label="Previous image"
            className="absolute left-2 top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-black/50 text-white transition-colors hover:bg-black/70"
          >
            <IoChevronBack className="h-5 w-5" aria-hidden="true" />
          </button>
          <button
            type="button"
            onClick={() => paginate(1)}
            aria-label="Next image"
            className="absolute right-2 top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-black/50 text-white transition-colors hover:bg-black/70"
          >
            <IoChevronForward className="h-5 w-5" aria-hidden="true" />
          </button>
          <span className="absolute right-3 top-3 rounded-md bg-black/55 px-2 py-1 text-xs text-white">
            {index + 1} / {images.length}
          </span>
          <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-2">
            {images.map((_, dotIndex) => (
              <button
                key={dotIndex}
                type="button"
                onClick={() => goTo(dotIndex)}
                aria-label={`Show image ${dotIndex + 1}`}
                aria-current={dotIndex === index ? "true" : undefined}
                className={`h-2.5 rounded-full transition-all ${dotIndex === index ? "w-6 bg-white" : "w-2.5 bg-white/50 hover:bg-white/80"
                  }`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

const Work = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  const handleProjectClick = (projectId) => {
    const project = projects.find((p) => p.id === projectId);
    setSelectedProject(project);
  };

  const projects = [
    // {
    //   id: 1,
    //   title: "HK Restaurant",
    //   path: hkRestaurant,
    //   link: "https://hk-restaurant.netlify.app/",
    //   code: "https://github.com/Heinkhantphyoe/HK-restaurant",
    //   details:
    //     "My first complete web project focused on restaurant browsing and menu presentation.",
    //   problem: "Built to provide a simple online menu and ordering experience for local users.",
    //   stack: ["HTML", "CSS", "Bootstrap", "JavaScript"],
    // },
    {
      id: 1,
      title: "Full-stack E-commerce web app",
      images: [
        giftoriaHome,
        giftoriaProduct,
        giftoriaAdminDashboard,
        giftoriaAdminProduct,
        giftoriaAdminOrder,
      ],
      code: "https://github.com/Heinkhantphyoe/flower-shop",
      details:
        "An e-commerce gift shop with catalog browsing, cart and wishlist, checkout with coupons, order history, and a role-based admin dashboard for catalog, coupons, and sales analytics. Auth covers email/OTP, password reset, JWT refresh, and Google sign-in. An AI chatbot helps with product questions. Carts and chat sessions live in Redis; products and orders live in PostgreSQL.",
      stack: ["React", "Vite", "Redux Toolkit", "Tailwind CSS", "Java 21", "Spring Boot", "JWT", "PostgreSQL", "Redis", "Docker"],
    },
    {
      id: 2,
      title: "Sar Mal",
      images: [sarMal],
      code: "https://github.com/one-project-one-month/food-ordering-system-java",
      details:
        "A team-built food-ordering platform where I contributed as a backend developer.",
      problem: "Designed to streamline order flow across customers, restaurants, delivery partners, and admins.",
      stack: ["Java", "Spring Boot", "MySQL", "REST API"],
    },
    {
      id: 3,
      title: "Movie Explorer",
      images: [movieExplorer, hkRestaurant],
      link: "https://hkp-movie-web.vercel.app/",
      code: "https://github.com/Heinkhantphyoe/Movie",
      details:
        "A movie web app where users can search titles, view details, and watch trailers using React and the TMDB API.",
      problem: "Built to make movie discovery faster with a clean search and detail flow.",
      stack: ["React", "JavaScript", "TMDB API", "CSS"],
    },
    {
      id: 4,
      title: "Trip Genie",
      images: [
        tripGenieHomeEng,
        tripGenieHomeMm,
        tripGenieDestination,
        tripGenieDate,
        tripGenieTravellers,
        tripGenieBudget,
        tripGenieInterest,
        tripGenieResult,
        tripGenieFlight,
        tripGenieHotels,
        tripGenieTips,
      ],
      link: "https://ai-trip-genie-77.vercel.app/",
      code: "https://github.com/Heinkhantphyoe/Trip-Genie",
      details:
        "TripGenie is a React single-page application for trip/travel planning. It features destination search with Nominatim geocoding, flight and hotel search, budget estimation, itinerary creation, and practical travel tips — orchestrated through a system of specia",
      stack: [
        "Vite 8",
        "React",
        "Tailwind CSS 4",
        "React Router DOM 7",
        "react-i18next",
        "Lucide React",
        "Gemini 2.5 Flash",
        "DeepSeek V4 Flash",
        "OpenAI GPT-4o-mini",
      ]
    }


  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen pt-10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 dark:text-white mt-14 md:mt-12 mb-3">Projects</h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto mb-8">Selected work that highlights how I design, build, and deliver practical products.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project) => (
            <div
              key={project.id}
              className="bg-white/90 dark:bg-gray-900/80 rounded-lg border border-gray-200 dark:border-gray-800 shadow-sm overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-md group"
            >
              <div className="aspect-w-16 aspect-h-9 overflow-hidden">
                <img
                  src={project.images[0]}
                  alt={project.title}
                  className="w-full h-48 object-cover object-center group-hover:scale-110 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">{project.title}</h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm mb-4 line-clamp-2">{project.details}</p>
                <p className="text-gray-500 dark:text-gray-400 text-sm mb-4">{project.problem}</p>
                <div className="flex flex-wrap gap-2 mb-5">
                  {project.stack.map((item) => (
                    <span key={item} className="text-xs px-2.5 py-1 rounded-md border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300">
                      {item}
                    </span>
                  ))}
                </div>
                <div className="flex justify-between items-center">
                  <div className="flex gap-4">
                    {project.link && (
                      <a
                        href={project.link}
                        target="_blank"
                        rel="noreferrer"
                        className="px-4 py-2 bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 rounded-md text-sm font-medium transition-all duration-300 border border-gray-300 dark:border-gray-700 hover:border-gray-500"
                      >
                        View Demo
                      </a>
                    )}
                    <button
                      onClick={() => handleProjectClick(project.id)}
                      className="px-4 py-2 bg-gray-900 hover:bg-gray-800 dark:bg-white dark:hover:bg-gray-200 text-white dark:text-gray-900 rounded-md text-sm font-medium transition-all duration-300"
                    >
                      Details
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {selectedProject && (
          <div className="fixed inset-0 z-50 overflow-y-auto bg-black/50 p-4 backdrop-blur-sm">
            <div className="flex min-h-full items-start justify-center sm:items-center">
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                className="relative w-full max-w-2xl rounded-lg border border-gray-200 bg-white p-5 shadow-xl dark:border-gray-800 dark:bg-gray-900 md:p-8"
              >
                <button
                  type="button"
                  onClick={() => setSelectedProject(null)}
                  aria-label="Close project details"
                  className="absolute top-4 right-4 text-gray-400 hover:text-primary transition-colors duration-200"
                >
                  <AiFillCloseCircle className="w-6 h-6" />
                </button>

                <div className="space-y-6">
                  <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 dark:text-white pr-10">
                    {selectedProject.title}
                  </h2>

                  <ProjectImageSlider
                    key={selectedProject.id}
                    images={selectedProject.images}
                    title={selectedProject.title}
                  />

                  <div className="prose prose-lg dark:prose-invert max-w-none">
                    <p className="text-gray-600 dark:text-gray-400">
                      {selectedProject.details}
                    </p>
                    <p className="text-gray-500 dark:text-gray-400">{selectedProject.problem}</p>
                    <div className="flex flex-wrap gap-2 pt-2">
                      {selectedProject.stack.map((item) => (
                        <span key={item} className="text-xs px-2.5 py-1 rounded-md border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300">
                          {item}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="flex gap-4 pt-4">
                    {selectedProject.code && (
                      <a
                        href={selectedProject.code}
                        target="_blank"
                        rel="noreferrer"
                        className="px-6 py-3 bg-gray-900 hover:bg-gray-800 dark:bg-white dark:hover:bg-gray-200 text-white dark:text-gray-900 rounded-md font-medium transition-all duration-300 flex items-center gap-2"
                      >
                        View Source
                      </a>
                    )}
                    {selectedProject.link && (
                      <a
                        href={selectedProject.link}
                        target="_blank"
                        rel="noreferrer"
                        className="px-6 py-3 bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 rounded-md font-medium transition-all duration-300 flex items-center gap-2 border border-gray-300 dark:border-gray-700 hover:border-gray-500"
                      >
                        Live Demo
                      </a>
                    )}
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        )}
      </AnimatePresence>
      <div className="px-4 lg:px-32 pt-10 pb-14 rounded-xl transition-all duration-200 mt-16">
        <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-10">
          <div>
            <p className="text-3xl mb-8 text-primary">Core Skills</p>

            <div className="skill mb-6">
              <div className="flex justify-between items-center mb-2">
                <p>Web Design</p>
                <p>Advanced</p>
              </div>
              <div>
                <div className="h-1 bg-gray-200 dark:bg-gray-700 w-full rounded-md transition-all duration-200 shadow-inner"></div>
                <div className="w-[90%] h-1 bg-green-400 mt-[-4.2px]  rounded-md"></div>
              </div>
            </div>
            <div className="skill mb-6">
              <div className="flex justify-between items-center mb-2">
                <p>Mobile Apps</p>
                <p>Intermediate</p>
              </div>
              <div>
                <div className="h-1 bg-gray-200 dark:bg-gray-700 w-full rounded-md transition-all duration-200 shadow-inner"></div>
                <div className="w-[60%] h-1 bg-red-400 mt-[-4.2px]  rounded-md"></div>
              </div>
            </div>
            <div className="skill mb-6">
              <div className="flex justify-between items-center mb-2">
                <p>REST API Development</p>
                <p>Advanced</p>
              </div>
              <div>
                <div className="h-1 bg-gray-200 dark:bg-gray-700 w-full rounded-md transition-all duration-200 shadow-inner"></div>
                <div className="w-[90%] h-1 bg-violet-400 mt-[-4.2px]  rounded-md mb-2"></div>
              </div>
            </div>
          </div>

          <div>
            <p className=" text-3xl mb-8 text-primary">Knowledge Areas</p>

            <div className="flex flex-wrap gap-4">
              <p className="py-2 px-7 rounded-md text-gray-600 dark:text-gray-400 bg-gray-300 dark:bg-gray-900 inline-block transition-all duration-200 shadow-lg hover:shadow-xl dark:shadow-gray-900/10 hover:bg-primary hover:text-white dark:hover:bg-primary">
                Object-Oriented Programming (OOP)
              </p>
              <p className="py-2 px-7 rounded-md text-gray-600 dark:text-gray-400 bg-gray-300 dark:bg-gray-900 inline-block transition-all duration-200 shadow-lg hover:shadow-xl dark:shadow-gray-900/10 hover:bg-primary hover:text-white dark:hover:bg-primary">
                Cloud Computing(AWS)
              </p>
              <p className="py-2 px-7 rounded-md text-gray-600 dark:text-gray-400 bg-gray-300 dark:bg-gray-900 inline-block transition-all duration-200 shadow-lg hover:shadow-xl dark:shadow-gray-900/10 hover:bg-primary hover:text-white dark:hover:bg-primary">
                Database Design & Management
              </p>
              <p className="py-2 px-7 rounded-md text-gray-600 dark:text-gray-400 bg-gray-300 dark:bg-gray-900 inline-block transition-all duration-200 shadow-lg hover:shadow-xl dark:shadow-gray-900/10 hover:bg-primary hover:text-white dark:hover:bg-primary">
                RESTful API Development
              </p>
              <p className="py-2 px-7 rounded-md text-gray-600 dark:text-gray-400 bg-gray-300 dark:bg-gray-900 inline-block transition-all duration-200 shadow-lg hover:shadow-xl dark:shadow-gray-900/10 hover:bg-primary hover:text-white dark:hover:bg-primary">
                Responsive Web Design
              </p>
              <p className="py-2 px-7 rounded-md text-gray-600 dark:text-gray-400 bg-gray-300 dark:bg-gray-900 inline-block transition-all duration-200 shadow-lg hover:shadow-xl dark:shadow-gray-900/10 hover:bg-primary hover:text-white dark:hover:bg-primary">
                Version Control
              </p>
              <p className="py-2 px-7 rounded-md text-gray-600 dark:text-gray-400 bg-gray-300 dark:bg-gray-900 inline-block transition-all duration-200 shadow-lg hover:shadow-xl dark:shadow-gray-900/10 hover:bg-primary hover:text-white dark:hover:bg-primary">
                Web Security Principles
              </p>
              <p className="py-2 px-7 rounded-md text-gray-600 dark:text-gray-400 bg-gray-300 dark:bg-gray-900 inline-block transition-all duration-200 shadow-lg hover:shadow-xl dark:shadow-gray-900/10 hover:bg-primary hover:text-white dark:hover:bg-primary">
                Data Structures & Algorithms
              </p>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Work;
